export enum CoverageActions {
  RECALCULATE = 'RECALCULATE',
  RESETCOVERAGE = 'RESETCOVERAGE'
}
